'use strict';

var jsxRuntime = require('react/jsx-runtime');

var e=jsxRuntime.jsx("g",{viewBox:"0 0 22 14",fill:"none",children:jsxRuntime.jsx("path",{d:"M19 11L11 2.5L3 11",stroke:"currentColor",strokeWidth:"3",strokeLinecap:"square"})});

exports.IconChevronUp = e;
